import React, { useEffect, useState } from 'react';
import { Badge, Box, ButtonBase, Grid, Typography } from '@mui/material';
import { PointOfSale, Payments, PrecisionManufacturing, Inventory2, PhoneInTalk, CardGiftcard, LocalShipping, ReceiptLong } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

type Tile = { label: string; sub: string; path: string; icon: React.ReactNode; color: string; badge?: number };

const MobileHomePage: React.FC = () => {
  const navigate = useNavigate();
  const [pending, setPending] = useState<{ calls: number; collections: number; stock: number } | null>(null);
  const [deliveries, setDeliveries] = useState(0);

  useEffect(() => {
    api.getPendingDeliveries().then(r => setDeliveries(r.length)).catch(() => setDeliveries(0));
    (async () => {
      try {
        const t = await api.getCommercialToday();
        setPending({
          calls: t.calls.length + t.suggestedCalls.length,
          collections: t.collections.length,
          stock: t.stockAlerts.length,
        });
      } catch {
        setPending(null);
      }
    })();
  }, []);

  const tiles: Tile[] = [
    { label: 'Vender', sub: 'Cargar una venta', path: '/m/vender', icon: <PointOfSale sx={{ fontSize: 44 }} />, color: '#2563eb' },
    { label: 'Cobrar', sub: 'Registrar un pago', path: '/m/cobrar', icon: <Payments sx={{ fontSize: 44 }} />, color: '#16a34a', badge: pending?.collections },
    { label: 'Hoy', sub: 'A quién llamar', path: '/m/hoy', icon: <PhoneInTalk sx={{ fontSize: 44 }} />, color: '#0ea5e9', badge: pending?.calls },
    { label: 'Producir lote', sub: 'Cargar producción', path: '/m/producir', icon: <PrecisionManufacturing sx={{ fontSize: 44 }} />, color: '#ea580c' },
    { label: 'Stock', sub: 'Qué me queda', path: '/m/stock', icon: <Inventory2 sx={{ fontSize: 44 }} />, color: '#7c3aed', badge: pending?.stock },
    { label: 'Regalo / pérdida', sub: 'Muestras y roturas', path: '/m/salida', icon: <CardGiftcard sx={{ fontSize: 44 }} />, color: '#db2777' },
    { label: 'Entregas', sub: 'Pedidos a entregar', path: '/m/entregas', icon: <LocalShipping sx={{ fontSize: 44 }} />, color: '#15803d', badge: deliveries },
    { label: 'Cargar gasto', sub: 'Nafta, flete, deuda', path: '/m/gasto', icon: <ReceiptLong sx={{ fontSize: 44 }} />, color: '#475569' },
  ];

  return (
    <Grid container spacing={2}>
      {tiles.map(t => (
        <Grid item xs={6} key={t.path}>
          <ButtonBase
            onClick={() => navigate(t.path)}
            sx={{
              width: '100%',
              minHeight: 150,
              borderRadius: 3,
              bgcolor: t.color,
              color: '#fff',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
              p: 2,
              boxShadow: 2,
              '&:active': { transform: 'scale(0.98)' },
            }}
          >
            <Badge badgeContent={t.badge || 0} color="error" overlap="circular" max={99}>
              {t.icon}
            </Badge>
            <Box textAlign="center">
              <Typography variant="h6" fontWeight={800} lineHeight={1.1}>{t.label}</Typography>
              <Typography variant="body2" sx={{ opacity: 0.85 }}>{t.sub}</Typography>
            </Box>
          </ButtonBase>
        </Grid>
      ))}
    </Grid>
  );
};

export default MobileHomePage;
